import React from 'react';
import Rating from './Rating';
import styles from './RatingBox.module.css';

function RatingBox({ label, count, value, onChange, filledColor, hoverColor = filledColor, color, disableHover = false }) {

    return (
        <div className={styles.ratingBoxContainer}>
            <label className={styles.label}>{label}</label>
            <div className={styles.ratingBox}>
                <Rating
                    count={count}
                    value={value || 0}
                    onChange={onChange}
                    color={color}
                    filledColor={filledColor}
                    hoverColor={hoverColor}
                    disableHover={disableHover}
                />
            </div>
        </div>
    );
}

export default RatingBox;
